import React, { useRef, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert
} from 'reactstrap';
import SignatureCanvas from 'react-signature-canvas';

const SignatureModal = ({ isOpen, onClose, onSave, title = "Firma Digital" }) => {
  const sigCanvas = useRef({});
  const [isEmpty, setIsEmpty] = useState(true);

  const clearSignature = () => {
    sigCanvas.current.clear();
    setIsEmpty(true);
  };

  const saveSignature = () => {
    if (sigCanvas.current.isEmpty()) {
      setIsEmpty(true);
      return;
    }

    // Obtener el canvas con la firma
    const canvas = sigCanvas.current.getTrimmedCanvas();
    
    // Convertir el canvas a blob y luego a File
    canvas.toBlob((blob) => {
      // Crear un archivo con nombre único basado en timestamp
      const timestamp = new Date().getTime();
      const fileName = `firma_${timestamp}.png`;
      
      // Crear un objeto File desde el blob
      const signatureFile = new File([blob], fileName, {
        type: 'image/png',
        lastModified: Date.now()
      });
      
      // Llamar la función onSave con el archivo de imagen
      onSave(signatureFile);
      
      // Cerrar el modal
      onClose();
      
      // Limpiar la firma
      clearSignature();
    }, 'image/png', 0.9); // Calidad del 90%
  };

  const handleBeginStroke = () => {
    setIsEmpty(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered>
      <ModalHeader toggle={onClose}>
        {title}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md={12}>
            <Alert color="info" className="mb-3">
              <strong>Instrucciones:</strong> Use su mouse, dedo o stylus para firmar en el área de abajo. 
              Puede limpiar y volver a firmar si es necesario.
            </Alert>
            
            <div 
              style={{ 
                border: '2px dashed #dee2e6', 
                borderRadius: '8px',
                padding: '10px',
                backgroundColor: '#f8f9fa'
              }}
            >
              <SignatureCanvas
                ref={sigCanvas}
                penColor="black"
                canvasProps={{
                  width: 500,
                  height: 200,
                  className: 'signature-canvas',
                  willReadFrequently: true,
                  style: {
                    width: '100%',
                    height: '200px',
                    backgroundColor: 'white',
                    borderRadius: '4px'
                  }
                }}
                onBegin={handleBeginStroke}
              />
            </div>
            
            {isEmpty && (
              <Alert color="warning" className="mt-2 mb-0">
                Por favor, agregue su firma antes de guardar.
              </Alert>
            )}
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={clearSignature}>
          <i className="mdi mdi-eraser me-1"></i>
          Limpiar
        </Button>
        <Button 
          onClick={saveSignature} 
          disabled={isEmpty}
          style={{
            backgroundColor: '#4CAF50',
            borderColor: '#4CAF50',
            color: '#ffffff'
          }}
        >
          <i className="mdi mdi-content-save me-1"></i>
          Guardar Firma
        </Button>
        <Button color="light" onClick={onClose}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SignatureModal;